import { render, staticRenderFns } from "./PasswordChangedIcon.vue?vue&type=template&id=49fb3513&scoped=true&"
import script from "./PasswordChangedIcon.vue?vue&type=script&lang=js&"
export * from "./PasswordChangedIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49fb3513",
  null
  
)

export default component.exports